// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-card {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

.name_style {
  float: left;
  position: relative;
  top: 2%;
}

.event_style {
  float: left;
  position: relative;
  top: 2%;
}

.name_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  font-size: 12px !important;
  height: 30px !important;
  padding-left: 5px;
}
.name_feild input::placeholder {
  font-size: 12px !important;
}

.name_feild::placeholder {
  font-size: 12px !important;
}

.event_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  padding-left: 5px;
  height: 30px !important;
  font-size: 12px !important;
}

.event_feild::placeholder {
  font-size: 12px !important;
}

.mar-feild {
  margin-top: -43px;
}

.fileFilter {
  margin-left: 20%;
}

.api_feild {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  float: left;
  height: 30px !important;
  font-size: 12px !important;
}

.messagetype_feild {
  width: 100%;
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.source_feild {
  width: 100%;
  float: left;
}

.target_feild {
  width: 100%;
  float: left;
}

.suffix_feild {
  width: 100%;
  height: 30px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
  font-size: 12px !important;
}
.suffix_feild .mat-form-field-appearance-legacy .mat-form-field-infix {
  margin-top: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 3% !important;
  font-size: 12px !important;
}

.InterFacetype {
  width: 100%;
  height: 35px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.cdk-overlay-container {
  isolation: isolate;
  z-index: 1000 !important;
}

::ng-deep.cdk-overlay-container, .cdk-global-overlay-wrapper, .cdk-overlay-connected-position-bounding-box {
  isolation: isolate;
  z-index: 9000 !important;
}

.processer_feild {
  width: 100%;
  float: left;
  position: relative;
}
.processer_feild input {
  height: 30px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  font-size: 12px !important;
  padding-left: 5px;
}
.processer_feild input::placeholder {
  font-size: 12px !important;
}
.processer_feild .btn_process {
  padding-block: 38% !important;
}

.notes_feild {
  float: left;
  font-size: 12px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -2.5% !important;
}

.agents_fontsize {
  font-size: 12px !important;
}

.event_feild_radius {
  border-radius: 4px !important;
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

::ng-deep.processormodaledit .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.processormodaledit {
  top: 16% !important;
  width: 85vw;
  height: 83vh !important;
  left: 12%;
}

.selectpipeline {
  width: 87%;
}

.notselectedpipeline {
  width: 76%;
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

::ng-deep.procagentcheckbox.mat-mdc-checkbox .mdc-label {
  margin-bottom: 2px;
  font-size: 12px !important;
}
::ng-deep.procagentcheckbox.mat-mdc-checkbox .mdc-checkbox {
  padding-right: 0px;
}
::ng-deep.procagentcheckbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.procagentcheckbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.procagentcheckbox.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

.conversiontype {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 4px;
  border: none;
  height: 28px;
  position: relative;
}
.conversiontype input {
  border: none;
  width: 100%;
}

::ng-deep.processoreditor .editor-container .monaco-editor {
  height: 137px !important;
}
::ng-deep.processoreditor .editor-container .monaco-editor .overflow-guard {
  height: 137px !important;
}
::ng-deep.processoreditor .editor-container .monaco-editor .overflow-guard .margin {
  height: 135px !important;
}
::ng-deep.processoreditor .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element {
  height: 135px !important;
}

::ng-deep.modal.myCustomModalClass {
  top: 16% !important;
  height: 80vh !important;
  left: 12% !important;
}

::ng-deep.modalConfigJSON .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 0% !important;
  right: 4% !important;
}
::ng-deep.modalConfigJSON .modal-dialog .modal-content {
  width: 80vw !important;
}

::ng-deep.modalConfigJSON .messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  min-width: 0 !important;
}
::ng-deep.modalConfigJSON .messageioteditor .editor-container .monaco-editor {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep.modalConfigJSON .messageioteditor .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}
::ng-deep.modalConfigJSON .messageioteditor .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  max-width: 100% !important;
}
::ng-deep.modalConfigJSON .messageioteditor .editor-container .monaco-editor .minimap {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  position: absolute !important;
  right: 0 !important;
  z-index: 1 !important;
  visibility: visible !important;
  display: block !important;
}`, "",{"version":3,"sources":["webpack://./src/app/agents/processor/processor.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACE,oDAAA;AAAF;;AAIA;EACE,WAAA;EACE,kBAAA;EACA,OAAA;AADJ;;AAIA;EACE,WAAA;EACE,kBAAA;EACA,OAAA;AADJ;;AAIA;EACE,oDAAA;EACA,WAAA;EACA,0BCpBS;EDuBP,uBCpBS;EDqBT,iBAAA;AAHJ;AAII;EACE,0BC1BK;ADwBX;;AAKA;EACE,0BC9BS;AD4BX;;AAIA;EACE,oDAAA;EACA,WAAA;EAGE,iBAAA;EACA,uBCnCS;EDoCT,0BCvCO;ADoCX;;AAKA;EACE,0BC1CS;ADwCX;;AAIA;EAEE,iBAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,oDAAA;EACA,WAAA;EACE,uBCpDS;EDqDT,0BCxDO;ADuDX;;AAGA;EACE,WAAA;EACA,uBCzDW;ED0DX,0BC7DS;ED8DT,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EAEA,uBCtFW;EDuFX,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BC9FS;AD+FX;AAAE;EACE,wBAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BCnGO;ADqGX;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;AACF;;AACA;EACE,kBAAA;EACA,wBAAA;AAEF;;AAAA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAGF;AAFE;EACE,uBC1HS;ED2HT,oDAAA;EACA,0BC/HO;EDgIP,iBAAA;AAIJ;AAFE;EACF,0BCnIW;ADuIX;AAFE;EACE,6BAAA;AAIJ;;AAAA;EACE,WAAA;EACA,0BC5IS;AD+IX;;AAAA;EACE,4BAAA;AAGF;;AAAA;EACE,0BCpJS;ADuJX;;AAAA;EACE,6BAAA;AAGF;;AAAA;EACE,sBAAA;AAGF;;AADA;EACE,yBAAA;EACA,eAAA;AAIF;;AAFA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAKF;;AAHA;EACE,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;AAMF;;AAHA;EACE,UAAA;AAMF;;AAJA;EACE,UAAA;AAOF;;AALA;EACE,iDAAA;AAQF;;AAJE;EACE,kBAAA;EACA,0BAAA;AAOJ;AALG;EACC,kBAAA;AAOJ;AANI;EACE,gCCnMM;EDoMN,oCCpMM;AD4MZ;AANI;EACE,YAAA;AAQN;AANE;EACE,YAAA;EACA,WAAA;AAQJ;;AAJA;EACI,oDAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAOJ;AANI;EACE,YAAA;EACA,WAAA;AAQN;;AAJE;EACE,wBAAA;AAOJ;AANI;EACE,wBAAA;AAQN;AAPM;EACE,wBAAA;AASR;AAPM;EACE,wBAAA;AASR;;AAJA;EACI,mBAAA;EACA,uBAAA;EACA,oBAAA;AAOJ;;AALA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AAQF;AAPE;EACE,sBAAA;AASJ;;AAHM;EACE,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;AAMR;AAJQ;EACE,sBAAA;EACA,0BAAA;AAMV;AAJU;EACE,sBAAA;EACA,0BAAA;EACA,2BAAA;AAMZ;AAJY;EACE,0BAAA;AAMd;AADU;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;AAGZ","sourcesContent":["@import \"../../../variables.scss\";\r\n.mat-card {\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n\r\n\r\n.name_style{\r\n  float: left;\r\n    position: relative;\r\n    top: 2%;\r\n\r\n}\r\n.event_style{\r\n  float: left;\r\n    position: relative;\r\n    top: 2%;\r\n }\r\n\r\n.name_feild{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  float: left;\r\n  font-size: $fontsize;\r\n    // width: 85%;\r\n    // margin-left: 3%;\r\n    height: $inputHeight;\r\n    padding-left: 5px;\r\n    input::placeholder {\r\n      font-size: $fontsize;\r\n        }\r\n}\r\n.name_feild::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.event_feild{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  float: left;\r\n    // width:76%;\r\n    // margin-left: 1%;\r\n    padding-left: 5px;\r\n    height: $inputHeight;\r\n    font-size: $fontsize;\r\n}\r\n.event_feild::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.mar-feild\r\n{\r\n  margin-top: -43px;\r\n}\r\n.fileFilter{\r\n  margin-left: 20%;\r\n}\r\n\r\n.api_feild{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  float: left;\r\n    height: $inputHeight;\r\n    font-size:$fontsize;\r\n}\r\n.messagetype_feild{\r\n  width: 100%;\r\n  height: $inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n.source_feild{\r\n  width: 100%;\r\n  float: left;\r\n  // margin-left: 1%;\r\n}\r\n.target_feild{\r\n  width: 100%;\r\n  float: left;\r\n  // margin-left: 8%;\r\n}\r\n.suffix_feild{\r\n  width: 100%;\r\n  // margin-left: 8%;\r\n  height: $inputHeight;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n  font-size:$fontsize;\r\n  .mat-form-field-appearance-legacy .mat-form-field-infix{\r\n    margin-top: 0 !important;\r\n    padding-bottom: 0 !important;\r\n    padding-top: 3%!important ;\r\n    font-size:$fontsize;\r\n  }\r\n}\r\n\r\n.InterFacetype{\r\n  width: 100%;\r\n  height: 35px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n\r\n::ng-deep.cdk-overlay-container {\r\n  isolation: isolate;\r\n  z-index: 1000 !important;\r\n}\r\n::ng-deep.cdk-overlay-container,.cdk-global-overlay-wrapper,.cdk-overlay-connected-position-bounding-box {\r\n  isolation: isolate;\r\n  z-index: 9000 !important;\r\n}\r\n.processer_feild{\r\n  width: 100%;\r\n  float: left;\r\n  position: relative;\r\n  input{\r\n    height:$inputHeight;\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    font-size: $fontsize;\r\n    padding-left: 5px;\r\n  }\r\n  input::placeholder {\r\nfont-size: $fontsize;\r\n  }\r\n  .btn_process{\r\n    padding-block: 38% !important;\r\n  }\r\n}\r\n\r\n.notes_feild{\r\n  float: left;\r\n  font-size: $fontsize;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -2.5% !important;\r\n}\r\n\r\n.agents_fontsize{\r\n  font-size: $fontsize;\r\n}\r\n\r\n.event_feild_radius{\r\n  border-radius: 4px!important;\r\n}\r\n\r\n.configtable td{\r\n  padding: 1%!important;\r\n}\r\n.configtable tr:hover {\r\n  background-color: #f3eded;\r\n  cursor: pointer;\r\n}\r\n::ng-deep.processormodaledit .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.processormodaledit{\r\n  top: 16% !important;\r\n  width: 85vw;\r\n  height: 83vh !important;\r\n  left: 12%;\r\n}\r\n\r\n.selectpipeline{\r\n  width:87%;\r\n}\r\n.notselectedpipeline{\r\n  width:76%;\r\n}\r\n.active_table{\r\n  background-color: #17a2b83b;\r\n}\r\n\r\n::ng-deep.procagentcheckbox.mat-mdc-checkbox{\r\n  .mdc-label{\r\n    margin-bottom: 2px;\r\n    font-size: 12px !important;\r\n  }\r\n   .mdc-checkbox{\r\n    padding-right: 0px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n}\r\n.conversiontype{\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    border-radius: 4px;\r\n    border: none;\r\n    height: 28px;\r\n    position: relative;\r\n    input{\r\n      border: none;\r\n      width: 100%;\r\n    }\r\n}\r\n::ng-deep.processoreditor .editor-container{\r\n  .monaco-editor{\r\n    height: 137px !important;\r\n    .overflow-guard{\r\n      height: 137px !important;\r\n      .margin{\r\n        height: 135px !important;\r\n      }\r\n      .monaco-scrollable-element{\r\n        height: 135px !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n::ng-deep.modal.myCustomModalClass{\r\n    top: 16% !important;\r\n    height: 80vh !important;\r\n    left: 12% !important;\r\n}\r\n::ng-deep.modalConfigJSON .modal-dialog {\r\n  max-width:80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n  top: 0%!important;\r\n  right:4% !important;\r\n  .modal-content{\r\n    width:80vw !important;\r\n  }\r\n}\r\n  // Handle minimap overflow in modalConfigJSON modal while keeping minimap enabled\r\n  ::ng-deep.modalConfigJSON {\r\n    .messageioteditor {\r\n      .editor-container {\r\n        overflow: hidden !important;\r\n        position: relative !important;\r\n        display: table !important;\r\n        width: 100% !important;\r\n        min-width: 0 !important;\r\n        \r\n        .monaco-editor {\r\n          width: 100% !important;\r\n          max-width: 100% !important;\r\n          \r\n          .overflow-guard {\r\n            width: 100% !important;\r\n            max-width: 100% !important;\r\n            overflow: hidden !important;\r\n            \r\n            .monaco-scrollable-element.editor-scrollable {\r\n              max-width: 100% !important;\r\n            }\r\n          }\r\n          \r\n          // Constrain minimap to prevent overflow - keep it visible and within modal bounds\r\n          .minimap {\r\n            width: 70px !important;\r\n            min-width: 70px !important;\r\n            max-width: 70px !important;\r\n            position: absolute !important;\r\n            right: 0 !important;\r\n            z-index: 1 !important;\r\n            visibility: visible !important;\r\n            display: block !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
